import React, { useState, useEffect } from "react";
import { motion, useViewportScroll, useTransform } from "framer-motion";
import FrontCircle from "../assets/FrontCircle";
import SubpageCircle from "../assets/SubpageCircle";
import Tube from "../assets/Tube";

const PageIntro = ({ customTitle, description, title, pageType }) => {
  const { scrollY } = useViewportScroll();

  const textOpacity = useTransform(scrollY, [0, 440], [1, 0]);

  const [initialDoughnutY, setInitialDoughnutY] = useState("0%");

  useEffect(() => {
    if (window.innerWidth < 768) {
      setInitialDoughnutY("30%");
    } else {
      setInitialDoughnutY("8%");
    }
  }, []);

  const doughnutY = useTransform(scrollY, [0, 1500], [initialDoughnutY, "-50%"]);

  if (pageType === "home-page") {
    return (
      <div className="intro-block container-fluid min-vh-100 d-flex flex-column">
        <div className="row flex-grow-1 h-100">
          <div
            className="page-intro col-xl-6 title-container d-flex align-items-end"
            style={{ position: "relative" }}
          >
            <div className="title fade-in-slide">
              <h1 className="mb-0">{customTitle}</h1>
            </div>
          </div>
          <div className="col-xl-6 circle position-relative">
            <FrontCircle />
          </div>
        </div>
      </div>
    );
  }
  else if (pageType === "content-page") {
    return (
      <div className="intro-block row justify-content-center content-page">
        <div className="page-intro col-lg-8">
          <motion.h1
            key="content-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {title}
          </motion.h1>
          {description && (
            <motion.h1
              key="content-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
            >
              <div className="description">
                <p
                  dangerouslySetInnerHTML={{ __html: description }}
                  className="p-body-1"
                />
              </div>
            </motion.h1>
          )}
        </div>
      </div>
    );
  }
  else if (pageType === "about-us-page") {
    return (
      <div className="intro-block container-fluid min-vh-100 d-flex flex-column">
        <div className="row flex-grow-1 h-100">
          <div
            className="page-intro col-xl-6 title-container"
            style={{ position: "relative" }}
          >
            <div className="title">
              <motion.h1
                key="about-title"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
              >
                <h1 className="mb-0">{customTitle}</h1>
              </motion.h1>
              <motion.h1
                key="about-description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
              >
                <div
                  className="p-body-1 mt-5"
                  dangerouslySetInnerHTML={{ __html: description }} 
                ></div>
              </motion.h1>
            </div>
          </div>
          <div className="col-xl-6 circle position-relative">
            <SubpageCircle />
          </div>
        </div>
      </div >
    );
  } else if (pageType === "investments-index-page") {
    return (
      <div className="intro-block container-fluid min-vh-100 d-flex flex-column">
        <div className="row flex-grow-1 h-100">
          <div
            className="page-intro col-lg-6 title-container"
            style={{ position: "relative" }}
          >
            <div className="title">
              <motion.h1
                key="ii-title"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
              >
                <h1 className="mb-0">{customTitle}</h1>
              </motion.h1>
              <motion.h1
                key="ii-description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
              >
                <div
                  className="p-body-1 mt-5"
                  dangerouslySetInnerHTML={{ __html: description }} 
                ></div>
              </motion.h1>
            </div>
          </div>
          <div className="col-lg-6 circle position-relative">
            <Tube />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="intro-block container-fluid">
        <div className="row">
          <div className="page-intro col-lg-6">
            <motion.h1
              key="other-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              {customTitle}
            </motion.h1>
            {description && (
              <motion.h1
                key="other-description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
              >
                <div className="description">
                  <p
                    dangerouslySetInnerHTML={{ __html: description }}
                    className="p-body-1"
                  />
                </div>
              </motion.h1>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default PageIntro;
